<template>
  <footer class="bg-blue-nutri flex items-center justify-between flex-wrap">
    <div class="w-full relative py-5 px-6 text-center text-white">
    © {{currentYear()}} Simply Good Food, LLC
    </div>
  </footer>
</template>

<script>
export default {

  data: function () {
    return {
    }
  },
  methods: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}

</script>
